export enum InvocationsPageState {
  gettingStarted = 'getting_started',
  list = 'list',
  setUp = 'set_up',
  noAccess = 'no_access',
}

export enum NotificationCategoryType {
  quotaAlmostUsed = 'quota_almost_used',
  quotaUsed = 'quota_used',
  subscriptionPending = 'subscription_pending',
  trialEnded = 'trial_ended',
  trialEndsIn24Hours = 'trial_ends_in_24_hours',
  trialEndsIn7Days = 'trial_ends_in_7_days',
}

export enum WorkspaceRoleType {
  owner = 'owner',
  workspaceContributor = 'workspace_contributor',
  workspaceViewer = 'workspace_viewer',
}

export enum BuildCacheActivationSourcePageType {
  appDetailsPage = 'app_details_invocations_page',
  buildDetailsBuildCacheTab = 'build_details_page_performance_tab',
  compareInvocations = 'compare_invocations',
  buildCacheGettingStartedPage = 'build_cache_getting_started_page',
  insightsExploreBuildCache = 'insights_explore_build_cache',
  invocationDetails = 'invocation_details',
  invocations = 'operations',
  billingPage = 'billing_page',
  buildCachePlanSelectorPage = 'build_cache_plan_selector_page',
  buildCacheSettingsPage = 'build_cache_settings_page',
}
